/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationResponseDto } from '../models/NotificationResponseDto';
import type { SendAnnouncementDto } from '../models/SendAnnouncementDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Send general announcement notification (superadmin only)
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public sendAnnouncement({
    requestBody,
  }: {
    requestBody: SendAnnouncementDto,
  }): CancelablePromise<NotificationResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/notifications/announcements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
